import React from "react";
import ImageSlider from "../../../shared/ui/ImageSlider";
import StoreButtons from "../../../shared/ui/StoreButtons";
import bigmallQRCode from "../../../assets/images/footer-app-downloads/BIGMALL-QR-CODE.png";

/** Main banner slider with the app download panel beside it on desktop. */
const HomeHero = ({ banners, loading }) => (
  <div className="home-hero">
    <div className="home-hero__slider">
      {loading ? (
        <div className="home-hero__placeholder" aria-hidden="true" />
      ) : (
        <ImageSlider banners={banners} className="" />
      )}
    </div>
    <aside className="home-hero__app d-none d-lg-flex" aria-label="Get the Bigmall app">
      <div className="home-hero__qr-frame">
        <img src={bigmallQRCode} alt="Scan to download the Bigmall app" className="home-hero__qr ui-qr" />
      </div>
      <StoreButtons compact />
    </aside>
  </div>
);

export default HomeHero;
